import { render, staticRenderFns } from "./PurchaseDaily.vue?vue&type=template&id=28da9d39"
import script from "./PurchaseDaily.vue?vue&type=script&lang=js"
export * from "./PurchaseDaily.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDaily.vue?vue&type=style&index=0&id=28da9d39&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports